module.exports = __webpack_public_path__ + "img/download-2-phone.6b0c9786.png";